import generic from './generic'
import compress from './compress'

const imagehelper = {
    generic,
    compress,
}

export default imagehelper